import { useContext } from 'react';
import { AppContext } from '../context';

export default function Footer() {
    const { appVersion } = useContext(AppContext);

    return (
        <footer className='footer p-2' style={{ zIndex: 999, position: 'fixed' }}>
            <div className='container-fluid'>
                <div className='row align-items-center'>
                    <div className='col-sm-6'>
                        <img
                            src='/assets/images/platec_light.png'
                            alt=''
                            width={100}
                        />
                    </div>
                    <div className='col-sm-6 mt-1'>
                        <div className='text-sm-end d-none d-sm-block'>
                            Programador de Turnos {appVersion}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
